/**
 * @generated SignedSource<<4221cb9d63cb5383e62d748ff4f4026c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type RedemptionTypeKey = "CHARITY" | "GIFT_CARD" | "MOBILE" | "PAYPAL" | "VENMO";
import { FragmentRefs } from "relay-runtime";
export type RedemptionFacets_redemptionTypes$data = {
  readonly id: string;
  readonly types: ReadonlyArray<{
    readonly id: string;
    readonly name: RedemptionTypeKey;
  }>;
  readonly " $fragmentType": "RedemptionFacets_redemptionTypes";
};
export type RedemptionFacets_redemptionTypes$key = {
  readonly " $data"?: RedemptionFacets_redemptionTypes$data;
  readonly " $fragmentSpreads": FragmentRefs<"RedemptionFacets_redemptionTypes">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./RedemptionFacetsRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "RedemptionFacets_redemptionTypes",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RedemptionType",
      "kind": "LinkedField",
      "name": "types",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "type": "RedemptionTypes",
  "abstractKey": null
};
})();

(node as any).hash = "2aa2650cd21e8ba28f21a573279cec8a";

export default node;
